import React from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Card } from 'primereact/card';

import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";

/**
 * A titled card with one DataTable per section, used by the approval dialog to show a member's details.
 * sections: [{ value, columns: [{field, header}], emptyMessage }]
 */
const MemberDetailsCard = ({ title, sections }) => (
  <div className="card home-chart">
    <Card>
      <center><h2 className="card-title home-chart">{title}</h2></center>

      <div className="card-body">
        {sections.map((section, index) => (
          <React.Fragment key={section.columns[0].field}>
            {index > 0 && <br />}
            <DataTable value={section.value} tableStyle={{ minWidth: '50rem' }} emptyMessage={section.emptyMessage}>
              {section.columns.map((col) => (
                <Column key={col.field} field={col.field} header={col.header} />
              ))}
            </DataTable>
          </React.Fragment>
        ))}
      </div>
    </Card>
  </div>
);

export default MemberDetailsCard;
